import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {ClassifiedMcc} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {Attachment} from '../types/email-data.types';
import {EmailService} from './email.service';
import {of} from 'rxjs/observable/of';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';
import {Observable} from 'rxjs/Observable';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class ClassifiedsMccService {
    isClassifiedsModalShow = false;

    classifiedInClassifiedModal: ClassifiedMcc;

    data = {
        allClassifiedsMcc: {
            get: '/v1/key_log.json?expand=building,suite,resident,incidentReportType,createdBy,activities',
            data: [],
            total: null
        },
    };
    tabId = 'allClassifiedsMcc';
    spinnerShow = true;
    buildings: Array<any> = [];

    constructor(
        public api: ApiClientService,
        public es: EmailService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData() {
        this.getDataByQueryParams().subscribe();
    }

    getDataByQueryParams() {
        this.data[this.tabId].total = null;
        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        return this.api.getJson('domainClassifiedsMcc', `${url}${queryParams}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(ClassifiedMcc.fromExistingData),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    (res) => {
                        this.data[tabId].data = res.entities;
                        this.data[tabId].total = res.total;
                        this.emptyRowService.fillEmptyRow();
                    },
                    (error) => {
                        this.spinnerShow = false;
                        this.data[tabId].data = [];
                        this.data[tabId].total = 0;
                        toastr.error('Failed to get Classifieds');
                    }
                )
            );
    }

    getBuildings(): void {
        this.getBuildingsRequest().subscribe();
    }

    getBuildingsRequest(): Observable<any> {
        if (this.buildings.length) return of(this.buildings);
        const url = `/v1/buildings.json?per-page=1000&order-by=name|asc`;
        return this.api.getJson('domainBD', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(
                    b => ({
                        ...b,
                        itemName: b.name
                    })
                ),
                tap(
                    (res) => this.buildings = res.entities,
                    (error) => this.api.errorHandler(error, 'Failed get buildings')
                )
            );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    deleteClassified(classified: ClassifiedMcc): void {
        if (!classified.id) return;
        swal(ConstantsService.getSwalConfig('Delete Classified'),
            () => {
                const url = `classified/${classified.id}`;
                this.api.remove('domainClassifieds', url).subscribe(
                    () => {
                        toastr.success('Classified has been deleted.');
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Failed to delete Classified')
                );
            }
        );
    }

    showAttachment(attachment) {
        const attachmentAsObject = new Attachment(attachment.name, 0, attachment.path);
        if (attachmentAsObject.isImage()) {
            this.es.attachmentInViewAttachmentModal = attachmentAsObject;
            this.es.isViewAttachmentModalShow = true;
        } else if (attachmentAsObject.isNeedViewer()) {
            attachmentAsObject.openViewer();
        } else {
            attachmentAsObject.downloadAttachment();
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/classifieds-mcc.service.ts